/**
 * Map tool registry — the single place future map tools register. `MapToolbox`
 * is a dumb renderer over this array, so adding a tool is purely additive: build
 * its panel, append one `MapTool` descriptor here. No edits to the toolbox, the
 * surface, or `MapShell` are needed.
 *
 * Order in this array == left-to-right order in the chip row under the search
 * bar (once 2+ tools exist).
 *
 * Gating note: a tool with `requiresWorkspace: true` renders disabled with an
 * actionable tooltip when no workspace is active.
 */
import { Crosshair } from 'lucide-react';
import { DropPinToolPanel } from '../DropPinToolPanel';
import { MapDrivingTimePanel } from '../MapDrivingTimePanel';
import { DrivingDistanceIcon } from './DrivingDistanceIcon';
import type { MapTool } from './mapTool.types';

/**
 * Tool id of the manual-pin tool, shared with `MapPinClickLayer` and the
 * `armedToolId` single-armed invariant.
 */
export const ADD_PIN_TOOL_ID = 'add-pin';

export const MAP_TOOLS: MapTool[] = [
  {
    id: ADD_PIN_TOOL_ID,
    label: 'New location',
    icon: Crosshair,
    requiresWorkspace: true,
    blockedWhileComputing: true,
    renderPanel: (ctx) => <DropPinToolPanel onClose={ctx.close} />,
  },
  {
    id: 'driving-time',
    label: 'Driving distance',
    icon: DrivingDistanceIcon,
    requiresWorkspace: false,
    renderPanel: (ctx) => <MapDrivingTimePanel shell={ctx.shell} onClose={ctx.close} />,
  },
];
